import { FETCH_PORTAL_CATEGORIES } from '../actions/types'

const initialState = []

export default (state = initialState, action) => {
  switch (action.type) {
    case FETCH_PORTAL_CATEGORIES:
      return action.payload
    case 'SET_LOCATION_CATEGORIES':
      return action.payload
    case 'SET_CURRENT_LOCATION':
      return initialState
    default:
      return state
  }
}
